import {
  TabSectionType,
  WorkspaceTab,
  WorkspaceTabSection,
} from '@ansys-internal/awf-angular/contributions';
import { ConceptSections } from '../../../../../shared/enums';
import { AWFSection } from '@ansys-internal/awf-angular/core';
import { IconType } from '@ansys-internal/awc-angular/icons';

@AWFSection({
  path: ConceptSections.CONFIGURATIONS,
})
export class VehicleSection implements TabSectionType {
  public type: ConceptSections = ConceptSections.CONFIGURATIONS;
  public title: string = 'Vehicle';
  public src: string = 'assets/icons/vehicle.svg';

  async getTitle(
    tab: WorkspaceTab,
    section: WorkspaceTabSection
  ): Promise<string> {
    return this.title;
  }

  async getIcon(
    tab: WorkspaceTab,
    section: WorkspaceTabSection
  ): Promise<IconType> {
    return {
      src: this.src,
    };
  }
}
